export const TICKET_TYPES = ['OPEN_ORDER', 'ADDRESS_MANAGEMENT', 'SUPPORT_REQUEST', 'BUILD'] as const;
export type TicketType = (typeof TICKET_TYPES)[number];
export type TicketTypeFilter = 'ALL' | TicketType;

export const PRIORITIES = ['LOW', 'NORMAL', 'HIGH', 'URGENT'] as const;
export type Priority = (typeof PRIORITIES)[number];

export interface StatusRow {
  status: string;
  count: number;
}

export interface WeeklyRow {
  day: string;
  created_count: number;
  open_count: number;
  in_progress_count: number;
  closed_count: number;
  reopened_count: number;
  resolved_count: number;
  breached_count: number;
  avg_hours: number | null;
  open_backlog: number;
}

export interface SlaSummary {
  total: number;
  response_met: number;
  response_missed: number;
  resolution_met: number;
  resolution_missed: number;
  breached: number;
  open_past_deadline: number;
}

export interface ResByPriorityRow {
  priority: string;
  resolved_count: number;
  avg_hours: number;
  median_hours: number;
}

export interface AssigneeRow {
  assignee: string;
  count: number;
}

export interface OperatorRow {
  operator: string;
  operator_code: string;
  count: number;
}

export interface ReportingScope {
  statusRows: StatusRow[];
  weeklyRows: WeeklyRow[];
  sla: SlaSummary;
  resByPriority: ResByPriorityRow[];
  assigneeRows: AssigneeRow[];
  operatorRows: OperatorRow[];
}

export interface RawTicket {
  ticketType: TicketType;
  category: string;
  priority: Priority;
  createdAt: string;
  closedAt: string | null;
  firstResponseAt: string | null;
}

export interface SubtypeCountRow {
  category: string;
  count: number;
}

export interface CategoryBreakdownRow {
  ticket_type: string;
  category: string;
  count: number;
}

export interface ResByTypeRow {
  ticket_type: string;
  resolved_count: number;
  avg_hours: number;
  median_hours: number;
}

export type Granularity = 'day' | 'week' | 'month' | 'year';
export type DayModeFilter = 'all' | 'business';

// Same standard the standalone report's SLA what-if simulator was set to use by default:
// a single company-wide reference SLA (hours), not the per-ticket-type tt_sla_configs values.
export const REFERENCE_SLA: { response: Record<Priority, number>; resolution: Record<Priority, number> } = {
  response: { URGENT: 24, HIGH: 24, NORMAL: 48, LOW: 120 },
  resolution: { URGENT: 48, HIGH: 72, NORMAL: 120, LOW: 240 },
};
